import React, {Component} from 'react';
import PropTypes from 'prop-types';
import accounting from 'accounting';
import {NumberHelper} from 'app/lib/numberHelper';
import {MoneyHelper} from "app/lib/moneyHelper";
import TextField from '@material-ui/core/TextField';

const INPUT_TYPE = 'text';
const MOBILE_INPUT_TYPE = 'tel';
const ASCII_COMMA_KEY_CODE = 188;
const ASCII_DOT_KEY_CODE = 190;
const MOBILE_ASCII_DECIMAL_KEY_CODE = 229;

export class AmountInput extends Component {
    static get propTypes() {
        return {
            label: PropTypes.string,
            type: PropTypes.string,
            value: PropTypes.number,
            onChange: PropTypes.func
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            value: 100,
            updatedValue: null,
            inputFocused: false,
        };

        this.inputType = this._determineInputType();
        this.handleChange = this.handleChange.bind(this);
        this.handleDecimalKeys = this.handleDecimalKeys.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const value = MoneyHelper.format(nextProps.value);

        if (prevState.value !== nextProps.value) {
            return prevState.inputFocused ? {updatedValue: value} : {value};
        }
    }

    componentDidMount() {
        this.setState({value: this.state.updatedValue});
    }

    handleDecimalKeys = (event) => {
        const input = event.target;
        if (input.selectionStart !== input.selectionEnd) {
            return;
        }

        if ((input.value.length - input.selectionStart) !== 3) {
            return;
        }

        let caretPosition = input.value.length - MoneyHelper.getPrecision;
        if (event.keyCode === MOBILE_ASCII_DECIMAL_KEY_CODE && this.inputType === MOBILE_INPUT_TYPE) {
            const regex = /_$/;

            if (regex.test(input.value)) {
                caretPosition -= 1;
            }

            window.setTimeout(() => {
                input.setSelectionRange(caretPosition, caretPosition);
            }, 0);

            return;
        }

        if (event.keyCode === ASCII_DOT_KEY_CODE && MoneyHelper.getDecimal === ',') {
            input.setSelectionRange(caretPosition, caretPosition);
        }

        if (event.keyCode === ASCII_COMMA_KEY_CODE && MoneyHelper.getDecimal === '.') {
            input.setSelectionRange(caretPosition, caretPosition);
        }
    };

    handleInputBlur = () => {
        this.setState({value: this.state.updatedValue, inputFocused: false});
    };

    handleChange = (event) => {
        const name = this.props.type;
        let value = event.target.value;

        if (value.match(/[a-z]/i)) {
            return;
        }

        this.setState({value, inputFocused: true});

        if (this._fixDecimals(value)) {
            value = parseFloat(value).toFixed(3).slice(0,-1);
            value = accounting.parse(value, MoneyHelper.getDecimal);
            value = accounting.toFixed(value * Math.pow(10, MoneyHelper.getPrecision));

            this.props.onChange(name, this._fixDecimals(value));
        }
    };

    /** @private */
    _fixDecimals(value) {
        value = value.replace(/\s/g, "");
        const patt = new RegExp("\\" + MoneyHelper.getDecimal, 'g');

        if (value.replace(patt, "") !== value) {
            value = NumberHelper.addMissingDecimalSign(value, MoneyHelper.getDecimal, MoneyHelper.getPrecision);
        }

        value = NumberHelper.fixDecimalSignPosition(value, MoneyHelper.getDecimal, MoneyHelper.getPrecision);

        return value;
    }

    /** @private */
    _determineInputType() {
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1 && ua.indexOf("mobile");

        return isAndroid ? MOBILE_INPUT_TYPE : INPUT_TYPE;
    }

    render() {
        return (
            <TextField
                label={this.props.label}
                name={this.props.type}
                onChange={this.handleChange}
                value={this.state.value}
                type={this.inputType}
                onBlur={this.handleInputBlur}/>
        )
    }
}
